<template src="./Index.html">
</template>
<script>
export default {
  created() {
    let id = this.$route.params.id;
    this.$store
      .dispatch("instructions/getForPrint", id)
      .then((res) => {        
        this.item = res;
      }).catch(() => { });
  },
  data() {
    return {
      item: {},

    };
  },
  computed: {
    user() {
      return this.$store.state.security.user;
    },
  },
  methods: {
    printReceipt() {
      window.print(); // فتح نافذة الطباعة
    },
  },
};
</script>
<style>

.receipt-a4 {
  max-width: 800px;
  margin: auto;
  padding: 20px;
}

.contact-footer {
  background: #f5f5f5;
  padding: 10px 0;
}
/* 
.contact-footer {
  position: absolute;
  bottom: 5px;
  left: 0;
  right: 0;
  font-size: 14px;
  color: #555;
} */

.clinic-name {
  font-size: 18px;
  font-weight: bold;
  color: #2c3e50;
  /* لون أزرق غامق */
  margin: 0;
}

.receipt-title {
  font-size: 16px;
  font-weight: bold;
  color: #83c783;
  /* لون أزرق */
}

/* تهيئة التصميم للطباعة بحجم A4 */
/* .receipt-a4 {
  width: 210mm;
  min-height: 290mm;
  margin: 0 auto;
  padding: 20px;
  background-color: white;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
} */

/* إعداد الطباعة */
@media print {
  .receipt-a4 {
    box-shadow: none;
    margin: 0;
  }

  body {
    margin: 0;
  }

  .v-btn {
    display: none;
    /* إخفاء زر الطباعة عند الطباعة */
  }
  
}

.text-h6 {
  color: #83c783;
}

h4,
h5,
span {
  font-family: "Almarai";
}

.text-caption {
  font-size: 12px;
  color: #666;
  margin-top: 10px;
}
</style>
